import React from 'react';
import cl from "./Sidebar.module.css";
import logo from "../../../../assets/images/logo.png"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faUser,
    faRightFromBracket,
    faHome,
    faRobot,
    faNewspaper,
    faPeopleRoof,
    faChartColumn, faBuilding, faHouseUser
} from "@fortawesome/free-solid-svg-icons";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {logOut} from "../../../../features/authentication/authenticationSlice";
import SidebarItem from "./SidebarItem/SidebarItem";
import ToggleSidebarItem from "./ToggleSidebarItem/ToggleSidebarItem";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import PermissionType from "../../../../data/enums/PermissionType";
import {useNavigate} from "react-router-dom";
import {selectCurrentUser} from "../../../../features/authentication/authenticationSelectors";

const Sidebar = () => {
    const user = useSelector(selectCurrentUser);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const logOutUser = () => {
        localStorage.removeItem('_d');
        dispatch(logOut());
    }

    const navigateToProfile = () => {
        navigate('/profile/me');
    }

    if (!user) {
        return <LoadingScreen/>
    }

    if (user && !user.permission) {
        throw new Error('User has no permissions');
    }

    return (
        <div className={cl.sidebar}>
            <div>
                <img className={cl.logo} src={logo} alt='logo'/>
            </div>
            <div>
                <SidebarItem path='/' text={t("sidebar.menu.main-page")} icon={<FontAwesomeIcon icon={faHome}/>}>

                </SidebarItem>
                <SidebarItem path='https://assistmob.a-100.by/admin/' text='Чат-бот Админ'
                             target='_blank' rel='noopener noreferrer' icon={<FontAwesomeIcon icon={faRobot}/>}/>
                {user.permission.alerts !== PermissionType.NotAvailable || user.permission.news !== PermissionType.NotAvailable || user.permission.newsSources !== PermissionType.NotAvailable || user.permission.views !== PermissionType.NotAvailable ?
                    <ToggleSidebarItem path='/news' text={t("sidebar.menu.posts")}
                        icon={<FontAwesomeIcon icon={faNewspaper} />}>
                        {user.permission.news !== PermissionType.NotAvailable ?
                            <SidebarItem path='/news/posts' text={t("sidebar.menu.news")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.views !== PermissionType.NotAvailable ?
                            <SidebarItem path='/news/pages' text={t("sidebar.menu.pages")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.newsSources !== PermissionType.NotAvailable ?
                            <SidebarItem path='/news/sources' text={t("sidebar.menu.post-sources")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.newsSources !== PermissionType.NotAvailable ?
                            <SidebarItem path='/news/imagetemplates' text={t("sidebar.menu.post-image-templates")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.newsSources !== PermissionType.NotAvailable ?
                            <SidebarItem path='/news/categories' text={t("sidebar.menu.post-categories")}>

                            </SidebarItem>
                            : null
                        }
                        {/*                    {user.permission.adds !== PermissionType.NotAvailable ?
                        <SidebarItem path='/news/banners' text={t("sidebar.menu.banners")}>

                        </SidebarItem>
                        : null
                    }*/}
                        {user.permission.newsSources !== PermissionType.NotAvailable ?
                            <SidebarItem end path='/news/links' text={t("sidebar.menu.links")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.newsSources !== PermissionType.NotAvailable ?
                            <SidebarItem end path='/news/certificates' text={t("sidebar.menu.certificates")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.alerts !== PermissionType.NotAvailable ?
                            <SidebarItem end path='/news/alerts' text={t("sidebar.menu.alerts")}>

                            </SidebarItem>
                            : null
                        }
                    </ToggleSidebarItem> : null
                }
                {user.permission.userLog !== PermissionType.NotAvailable ?

                    <ToggleSidebarItem path='/users' text={t("sidebar.menu.users")} icon={<FontAwesomeIcon icon={faUser} />}>
                        <SidebarItem end path='/users' text={t("sidebar.menu.users")}>

                        </SidebarItem>

                        <SidebarItem end path='/users/logs' text={t("sidebar.menu.user-logs")}>

                        </SidebarItem>


                    </ToggleSidebarItem>
                    : null
                }
                {user.permission.tsPolls !== PermissionType.NotAvailable || user.permission.erip !== PermissionType.NotAvailable ?
                <ToggleSidebarItem path='/ts' text={t("sidebar.menu.ts")} icon={<FontAwesomeIcon icon={faHouseUser}/>}>
                    {user.permission.tsPolls !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/ts/homeownerpolls' text={t("sidebar.menu.homeownerpolls")}>

                        </SidebarItem>
                        : null
                    }
                    {user.permission.erip !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/ts/homeownererips' text={t("sidebar.menu.homeownererips")}>

                        </SidebarItem>
                        : null
                    }
                    </ToggleSidebarItem> : null
                }
                {user.permission.accounts !== PermissionType.NotAvailable || user.permission.buildings !== PermissionType.NotAvailable || user.permission.barriers !== PermissionType.NotAvailable || user.permission.services !== PermissionType.NotAvailable ?
                <ToggleSidebarItem path='/property' text={t("sidebar.menu.property")} icon={<FontAwesomeIcon icon={faBuilding}/>}>


                    {user.permission.accounts !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/property/accounts' text={t("sidebar.menu.accounts")}>

                        </SidebarItem>
                        : null
                    }
                    {user.permission.buildings !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/property/buildings' text={t("sidebar.menu.buildings")}>

                        </SidebarItem>
                        : null
                    }
                    {user.permission.barriers !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/property/barriers' text={t("sidebar.menu.barriers")}>

                        </SidebarItem>
                        : null
                    }
                    {user.permission.services !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/property/services' text={t("sidebar.menu.services")}>

                        </SidebarItem>
                        : null
                    }
                    {user.permission.accounts !== PermissionType.NotAvailable ?
                        <SidebarItem end path='/property/sensors' text={t("sidebar.menu.sensors")}>

                        </SidebarItem>
                        : null
                    }
                    </ToggleSidebarItem> : null
                }

                {user.permission.admins !== PermissionType.NotAvailable || user.permission.settings !== PermissionType.NotAvailable
                    ? <ToggleSidebarItem path='/management' text={t("sidebar.menu.management")}
                                         icon={<FontAwesomeIcon icon={faPeopleRoof}/>}>
                        {user.permission.admins !== PermissionType.NotAvailable ?
                            <SidebarItem end path='/management/admins' text={t("sidebar.menu.admins")}>

                            </SidebarItem>
                            : null
                        }
                        {user.permission.settings !== PermissionType.NotAvailable ?
                            <SidebarItem end path='/management/settings' text={t("sidebar.menu.settings")}>

                            </SidebarItem>
                            : null
                        }


                    </ToggleSidebarItem>
                    : null
                }
                {user.permission.analytics !== PermissionType.NotAvailable ?
                <ToggleSidebarItem path='/analytics' text={t("sidebar.menu.analytics")}
                                   icon={<FontAwesomeIcon icon={faChartColumn}/>}>
                    <SidebarItem end path='/analytics/users' text={t("sidebar.menu.users")}>

                    </SidebarItem>
                    <SidebarItem end path='/analytics/users/active' text={t("sidebar.menu.active-users")}>

                    </SidebarItem>
                    <SidebarItem end path='/analytics/users/problem' text={t("sidebar.menu.problem-users")}>

                    </SidebarItem>
                </ToggleSidebarItem>: null
                }
            </div>
            <div>
                <div className={cl.userLogo}
                     title={t("sidebar.profile-label")}
                     onClick={navigateToProfile}>
                    <FontAwesomeIcon icon={faUser}/>
                </div>
                <div className={cl.userName}
                     title={t("sidebar.profile-label")}
                     onClick={navigateToProfile}>
                    {user && user.name}
                </div>
                <div className={cl.logOut}
                     title={t("sidebar.logOut-label")}
                     onClick={logOutUser}>
                    <FontAwesomeIcon icon={faRightFromBracket}/>
                </div>
            </div>
        </div>
    );
};

export default Sidebar;
